module.exports = __webpack_public_path__ + "static/virtual-reality-cell-culture--20dcd39b7f43dd1214f52ae84420c5db.jpg";